module.exports = __webpack_public_path__ + "static/sofiapro-200-ad91ea2c59ffdca4b5ea6f17920b2f19.woff";